import { useMemo } from 'react';
import type { JSX } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { useAuthHeartbeat } from '~/hooks/auth/useAuthHeartbeat';

const protectedRoutes = [
  '/apps',
  '/meu-perfil',
  '/notificacoes',
  '/gestao',
  '/gestao/:userId',
  '/gestao/:userId/veiling',
];

export default function AppHeartbeat(): JSX.Element | null {
  const location = useLocation();

  const isProtectedPath = useMemo(() => {
    return (pathname: string): boolean => {
      if (matchPath({ path: '/koa/*' }, pathname) || pathname === '/koa') {
        return false;
      }
      return protectedRoutes.some(route =>
        Boolean(matchPath({ path: route, end: true }, pathname)),
      );
    };
  }, []);

  useAuthHeartbeat({
    pathname: location.pathname,
    isProtectedPath,
  });

  return null;
}
